import React from "react";

import { FaUserEdit, FaEdit } from "react-icons/fa";

import UserAvatar from "../../common/components/UserAvatar";
import { PALETTE } from "../../common/ThemeConstants";
import { useNavigate } from "react-router-dom";

export default function AccountAvatar({
  background,
  size = 160,
  sizeInner = 150,
  fontSize = 50,
  showPercentageTag = true,
  completeText = "Completo",
  firstname = undefined,
  lastname = undefined,
  age = undefined,
  completionPercentage = 0,
  editable = false,
  onEdit = undefined,
  cover = undefined
}) {
  const navigate = useNavigate();
  const handleEditClick = () => {
    if (onEdit) {
      onEdit();
    } else {
      navigate("/account/AccountSettings");
    }
  };

  return (
    <div
      style={{ background: background }}
      className="rounded-md text-center align-self-center align-items-center"
    >

      <div className="text-center align-self-center align-items-center m-auto" style={{ width: "fit-content", height: "fit-content" }}>
        <div
          className="avatar-completion-container m-auto align-self-center"
          style={{
            position: "relative",
            width: size,
            height: size,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {/* Circular progress indicator */}
          <div
            className="avatar-completion-indicator"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              background: `conic-gradient(
                ${PALETTE.MAINCOLORHOVER} ${completionPercentage}%, 
                ${PALETTE.KINDAGRAY} ${completionPercentage}% 100%
              )`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {/* Edit icon with rounded-pill styling */}
            {editable && (
              <div
                onClick={handleEditClick}
                className="rounded-pill"
                style={{
                  position: "absolute",
                  top: "15",
                  right: "12",
                  background: PALETTE.LIGHTGRAY,
                  padding: "6px",
                  cursor: "pointer",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "35px",
                  height: "35px",
                  transform: "translate(25%, -25%)",
                }}
              >
                {onEdit ? (
                  <FaEdit color={PALETTE.DARKGRAY} size={16} />
                ) : (
                  <FaUserEdit color={PALETTE.TRUEGRAY} size={16} />
                )}
              </div>
            )}
            {/* Inner white circle to create donut effect */}
            <div style={{
              width: sizeInner,
              height: sizeInner,
              borderRadius: "50%",
              background: background || "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <UserAvatar
                firstname={firstname}
                lastname={lastname}
                cover={cover}
                color={PALETTE.SECONDARYCOLOR}
                background={PALETTE.GRADIENTLIGHT}
                size={sizeInner}
                fontSize={fontSize}
                borderColor="transparent" // Make the default border transparent since we're using the progress indicator
              />
            </div>
          </div>
        </div>
        {/* Completion percentage tag */}
        {showPercentageTag && (
          <div
            className="completion-percentage-tag"
            style={{
              backgroundColor: PALETTE.MAINCOLORHOVER,
              color: "#fff",
              padding: "2px 8px",
              borderRadius: "12px",
              fontSize: "14px",
              fontWeight: "bold",
              marginTop: "5px",
              display: "inline-block",
              marginTop: "-10px",
              zIndex: 100,
              position: "relative"
            }}
          >
            {completeText + " " + completionPercentage + "%"}
          </div>
        )}
        {firstname && age && (
          <>
            <br />
            <p style={{ fontSize: 24, color: PALETTE.SECONDARYCOLOR }}>{firstname}, {age}</p>
          </>
        )}
      </div>
    </div>
  );
}
